import React from 'react';
import { List, Typography, Card, Tag, Space, Row, Col, Popover } from 'antd';
import {
    TrophyOutlined,
    ClockCircleOutlined,
    FlagOutlined,
    StarOutlined,
    GiftOutlined,
    StopOutlined
} from '@ant-design/icons';
import styles from './index.module.css';
import { parseMarkdownLinks } from './utils';

const { Title, Paragraph, Text } = Typography;

const Rule2: React.FC = () => {
    const mainTrackData = [
        '2026 年 01 月 16 日 04:00 更新的深境螺旋 12 层上半三间连打竞速',
        '每间最多 4 次时停，超出一次最终成绩罚时 1s',
        '主赛道为严格上半三间连打，禁止使用拼接',
        '每名参赛者或每个 UID 有效投稿至多参与 2 条赛道名次评选，超出则以后投稿为准',
        '每名参赛者或每个 UID 每条赛道至多计入 1 条有效投稿，可用于提升赛后抽奖概率',
        '总耗时不超过 360s，且单间不超过 120s 视为有效成绩'
    ];

    const overallRules = [
        '所有赛道必须携带并使用烟绯',
        '伤害占比计算规则：视频中能看到的烟绯伤害数字总和 / 怪物血量',
        '相同成绩以投稿时间更早进行排序',
        '同一 UID 仅能由同一用户投稿',
        '最终解释权归主办方所有',
    ];

    const mainTrackReqs = [
        '参赛作品需注明赛道以及金数，话题选择需携带「灼灼杯」；',
        '投稿视频必须全程完整露出 UID，且不支持联合投稿、代投，投稿人即为参赛者',
        '投稿视频需至少保留至比赛结束 7 日内',
        '投稿完成后在评论区 [@烟绯三月夏扬州](https://space.bilibili.com/482036178) 且回复投稿后视为完成投稿；[网站上展示出投稿信息](https://www.yanfeifei.com/zhuozhuo) 视为审核完成；',
        '视频至少从选择「深秘降福」开始，且至少以出现「与此同时，另外一边」为结尾',
        '第二间第三间开始时展示历史「深秘降福」',
        '第三间结束时，需直接退出深渊录入角色面板、命座、武器以及圣遗物面板，要求大世界队伍即为深渊队伍，此段录制不得经过拼接',
        '烟绯伤害应为全队最高，且占比不低于 40%'
    ];

    const characterCosts = [
        '四星角色不计金数',
        '限定五星角色本体计算 1 金，后续每命座各计 1 金',
        '常驻五星角色本体计算 1 金，后续每命座各计 0.5 金'
    ];

    const weaponCosts = [
        '四星武器不计金数',
        '限定五星武器每精炼计 1 金',
        '常驻五星武器本体计 1 金，精炼不计金数',
    ];

    return (
        <div>
            {/* 头部标题区域 */}
            <Card className={styles.headerCard}>
                <div className={styles.headerContent}>
                    <Title level={1} className={styles.mainTitle}>
                        第二届灼灼杯开赛公告
                    </Title>
                </div>
                <Paragraph className={styles.contactInfo}>
                    <Text strong>参赛交流群：</Text>
                    <Popover
                        content={
                            <div style={{ textAlign: 'center' }}>
                                <img
                                    src="/zhuozhuo/group.jpg"
                                    alt="灼灼杯交流群二维码"
                                    style={{
                                        maxWidth: '250px',
                                        maxHeight: '300px',
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                    }}
                                />
                                <div style={{ marginTop: '8px', color: '#666', fontSize: '12px' }}>
                                    扫码加入交流群
                                </div>
                            </div>
                        }
                        title="【烟绯】灼灼杯"
                        trigger="hover"
                        placement="bottom"
                    >
                        <Tag color="blue" style={{ cursor: 'pointer' }}>1016648426</Tag>
                    </Popover>
                </Paragraph>
            </Card>

            <Row gutter={[24, 24]} className={styles.topRow}>
                {/* 开赛时间 */}
                <Col xs={24} lg={12}>
                    <Card className={styles.timeCard} title={
                        <Space>
                            <ClockCircleOutlined />
                            <span>开赛时间</span>
                        </Space>
                    }>
                        <div className={styles.timeItem}>
                            <Paragraph className={styles.timeText}>
                                2026 年 01 月 16 日 04:00 ~ 2026 年 02 月 13 日 03:59
                            </Paragraph>
                        </div>
                    </Card>
                </Col>

                {/* 赛道设置 */}
                <Col xs={24} lg={12}>
                    <Card className={styles.trackCard} title={
                        <Space>
                            <FlagOutlined />
                            <span>赛道设置</span>
                        </Space>
                    }>
                        <div className={styles.trackSection}>
                            <div className={styles.trackTags}>
                                <Tag color="orange">2 金赛道</Tag>
                                <Tag color="gold">6 金赛道</Tag>
                                <Tag color="red">12 金赛道</Tag>
                                <Tag color="green">无限制赛道</Tag>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* 比赛规则 */}
            <Card className={styles.rulesCard} title={
                <Space>
                    <StarOutlined />
                    <span>比赛规则</span>
                </Space>
            }>
                <Row gutter={[16, 16]}>
                    <Col xs={24} lg={12}>
                        <Card type="inner" title="整体规则" className={styles.innerCard}>
                            <List
                                size="small"
                                dataSource={overallRules}
                                renderItem={(item, index) => (
                                    <List.Item className={styles.ruleItem}>
                                        <span className={styles.ruleNumber}>{index + 1}</span>
                                        <span>{parseMarkdownLinks(item)}</span>
                                    </List.Item>
                                )}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                        <Card type="inner" title="主赛道规则" className={styles.innerCard}>
                            <List
                                size="small"
                                dataSource={mainTrackData}
                                renderItem={(item, index) => (
                                    <List.Item className={styles.ruleItem}>
                                        <span className={styles.ruleNumber}>{index + 1}</span>
                                        <span>{parseMarkdownLinks(item)}</span>
                                    </List.Item>
                                )}
                            />
                        </Card>
                    </Col>
                </Row>
            </Card>

            {/* 稿件要求 */}
            <Card className={styles.requirementsCard} title={
                <Space>
                    <TrophyOutlined />
                    <span>稿件要求</span>
                </Space>
            }>
                <List
                    size="small"
                    dataSource={mainTrackReqs}
                    renderItem={(item, index) => (
                        <List.Item className={styles.requirementItem}>
                            <span className={styles.reqNumber}>{index + 1}</span>
                            <span>{parseMarkdownLinks(item)}</span>
                        </List.Item>
                    )}
                />
            </Card>

            {/* 金数计算 */}
            <Card className={styles.costCard} title={
                <Space>
                    <StarOutlined />
                    <span>金数计算</span>
                </Space>
            }>
                <Row gutter={[16, 16]}>
                    <Col xs={24} lg={12}>
                        <Card type="inner" title="角色金数" className={`${styles.innerCard} ${styles.costInner}`}>
                            <List
                                size="small"
                                dataSource={characterCosts}
                                renderItem={(item, index) => (
                                    <List.Item className={styles.costItem}>
                                        <span className={styles.costBullet}>•</span>
                                        <span>{parseMarkdownLinks(item)}</span>
                                    </List.Item>
                                )}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                        <Card type="inner" title="武器金数" className={`${styles.innerCard} ${styles.costInner}`}>
                            <List
                                size="small"
                                dataSource={weaponCosts}
                                renderItem={(item, index) => (
                                    <List.Item className={styles.costItem}>
                                        <span className={styles.costBullet}>•</span>
                                        <span>{parseMarkdownLinks(item)}</span>
                                    </List.Item>
                                )}
                            />
                        </Card>
                    </Col>
                </Row>
            </Card>

            {/* 数帧规则 */}
            <Card className={styles.frameCard} title="关于数帧">
                <div>
                    <Paragraph className={styles.frameIntro}>
                        <Text strong>主赛道</Text>数帧规则如下：
                    </Paragraph>
                    <List
                        className={styles.frameRules}
                        dataSource={[
                            '统一 30 帧数帧（以必剪为准），计时器出现计第一帧，计时器消失前的最后一帧计为最后一帧',
                            '除去明显开局 09:59 外，若触发跳秒，需要严格自证或提供录屏源文件，否则不认可',
                            '若选手在开局和结尾使用时停，则无法使用数帧和判定跳秒',
                            '若因选手结尾使用时停导致计时器消失，则在时停前计时加一秒',
                            '若战斗结尾出现卡帧现象，重复帧不计入',
                        ]}
                        renderItem={(item, index) => (
                            <List.Item className={styles.frameRuleItem}>
                                <span className={styles.frameNumber}>{index + 1}</span>
                                <span>{parseMarkdownLinks(item)}</span>
                            </List.Item>
                        )}
                    />
                </div>
            </Card>

            {/* 底部信息 */}
            <Row gutter={[16, 16]} className={styles.bottomCardsRow}>
                <Col xs={24} lg={12}>
                    <Card className={styles.rewardCard} title={
                        <Space>
                            <GiftOutlined />
                            <span>比赛奖励（不可折现）</span>
                        </Space>
                    }>
                        <div className={styles.rewardContent} style={{ marginTop: 0 }}>
                            <Paragraph>任一有效投稿均可获得「命定之日系列角色徽章 2025 烟绯款」，同一用户仅能获得一个。</Paragraph>
                            <Paragraph>任意赛道前 3 名各可获得奖励（相同赛道不可重复获得）：</Paragraph>
                            <div className={styles.rewardTags}>
                                <div className={styles.rewardItem}>
                                    <Tag color="gold" className={styles.rewardTag}>第1名</Tag>
                                    <div className={styles.rewardText}>
                                        <div>命定之日系列翻页式花窗色纸 2025 烟绯款</div>
                                        <div>命定之日系列角色厚亚克力杯垫 2025 烟绯款</div>
                                    </div>
                                </div>
                                <div className={styles.rewardItem}>
                                    <Tag color="silver" className={styles.rewardTag}>第2名</Tag>
                                    <div className={styles.rewardText}>
                                        <div>命定之日系列角色厚亚克力杯垫 2025 烟绯款</div>
                                    </div>
                                </div>
                                <div className={styles.rewardItem}>
                                    <Tag color="#cd7f32" className={styles.rewardTag}>第3名</Tag>
                                    <div className={styles.rewardText}>
                                        <div>命定之日系列翻页式花窗色纸 2025 烟绯款</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.rewardContent}>
                            <Paragraph>有效投稿抽奖：</Paragraph>
                            <div className={styles.rewardTags}>
                                <div className={styles.rewardItem}>
                                    抽奖礼物：留影叙佳期系列角色立牌收藏卡套组烟绯款。
                                    <br/><br/>
                                    所有玩家每一有效投稿均可获得赛后抽奖点数。赛后总计每 4 个有效投稿累计 1 次抽奖机会（向上取整）。每个玩家相同抽奖礼物仅能抽中一次。
                                    <br/><br/>
                                    举例：玩家 A、B 具备 3 个有效投稿，玩家 C、D 具备 2 个有效投稿。那么总计抽奖 3 个（10/4），第一轮抽奖玩家 A、B 中奖概率各自为 3/10，玩家 C、D 中奖概率各自为 2/10。
                                    <br/><br/>
                                    假定玩家 A 在第一轮中奖，那么第二轮抽奖玩家 A 不参与抽奖，玩家 B 中奖概率为 3/7，玩家 C、D 中奖概率各自为 2/7。以此类推。
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col xs={24} lg={12}>
                    <Card className={styles.forbiddenCard} title={
                        <Space>
                            <StopOutlined />
                            <span>严格禁止</span>
                        </Space>
                    }>
                        <Paragraph className={styles.forbiddenText}>
                            使用鼠标宏在内的任意游戏外辅助工具。
                        </Paragraph>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Rule2;
